require('./ctxTag.style.scss');

class ctxTagController {
    constructor($element, $document) {
        this.$element = $element;
        this.$document = $document;
    }

    $onInit() {
        this.dropdown = false;
        this.hoursTime = this.setDropDownList(true);
        this.minutesTime = this.setDropDownList();
        this.currentSelected = 0;
        this.showCloseIcon = false;
    }

    setDropDownList(isHourArr) {
        let newArry = [],
            lastItem = { label: '00', isDisabled: false, lastValue: true, top: isHourArr ? 25 * 20 : 4 * 20 },
            firstItem = { label: isHourArr ? '24' : '45', isDisabled: false, firstValue: true, top: 0 },
            condition = isHourArr ? 24 : 3,
            increment = isHourArr ? 1 : 15;
        newArry.push(firstItem);
        for (let i = 0; i <= condition; i++) {
            newArry.push({
                label: i < 10 ? (!isHourArr && i > 0 ? '' : '0') + i * increment : (i * increment).toString(),
                isDisabled: false,
                top: i * -20
            })
        }
        newArry.push(lastItem);
        return newArry;
    }

    removeTag() {
        const tagId = this.id;
        this.onRemove({ tagId });
    }

    toggleDropdown(value, isHoursDropDown) {
        this.dropdown = !this.dropdown;
        this.openedValue = value;
        this.dropDownList = isHoursDropDown ? this.hoursTime : this.minutesTime;
        let type = isHoursDropDown ? 'hours' : 'minutes',
            item = this.dropDownList.filter(dl => dl.label === value[type] && !dl.firstValue && !dl.lastValue),
            mLeft = value.start ? isHoursDropDown ? -1 : 29 : isHoursDropDown ? 68 : 96,
            dropDown = this.$element.find('.custom-dropdown');
        dropDown.css('display', this.dropdown ? 'flex' : 'none');
        dropDown.css('margin-left', mLeft + 'px');

        this.$element.find('.time-wrapper').css('top', `${item[0].top}px`);
        this.activeItem = this.dropDownList.indexOf(item[0]);
        this.setDisabled(value, isHoursDropDown);
    }

    setValue(time) {
        let hours = this.isHoursDropDown() ? 'hours' : 'minutes',
            index = this.customValue.indexOf(this.openedValue);
        this.customValue[index][hours] = time.label;
        const tagId = this.id;
        this.onTagChange({ tagId })
        this.closeDropdown();
    }

    slideTime(i) {
        let nextItem = this.dropDownList[this.activeItem -= i];
        if (nextItem.lastValue) {
            this.activeItem = 1;
            nextItem = this.dropDownList[1];
        }
        if (nextItem.firstValue) {
            this.activeItem = this.dropDownList.length - 2;
            nextItem = this.dropDownList[this.dropDownList.length - 2];
        }
        this.$element.find('.time-wrapper').css('top', nextItem.top)
    }

    closeDropdown() {
        this.$element.find('.custom-dropdown').css('display', 'none');
        this.dropdown = false;
    }

    isHoursDropDown() {
        return this.dropDownList && this.dropDownList.length === 27;
    }

    setDisabled(value, isHours) {
        let oppositeItem = this.customValue.filter(cm => cm.start !== value.start),
            type = !isHours ? 'hours' : 'minutes',
            oppositeType = !isHours ? 'minutes' : 'hours';
        for (let i = 0; i < this.dropDownList.length; i++) {
            let list = this.dropDownList[i];
            list.isDisabled = (oppositeItem[0][type] === value[type] && oppositeItem[0][oppositeType] === list.label) || (!isHours && list.label !== '00' && value.hours === '24');
        }
    }

}

ctxTagController.$inject = ['$element', '$document'];

const ctxTagComponent = {
    controller: ctxTagController,
    template: require('./ctxTag.template.html'),
    scope: {},
    bindings: {
        id: '@',
        label: '@',
        color: '@',
        value: '@?',
        onRemove: '&',
        isDefaultValue: '<?',
        customValue: '<?',
        additionalText: '@?',
        haveTimePicker: '<?',
        onTagChange: '&?',
        isDragDrop: '<?',
        sendId: '<?'
    }
};

module.exports = ctxTagComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTag/ctxTag.component.js